export default {
    props:['timeOut'],
    data() {
		return {
			t: null
		}
	},
    methods: {
        doLogout(){
            axios.post(route('logout').url()).then(response => {
                window.location = '/';
            })
        },
        idleLogout() {
            window.onload = this.resetTimer;
            window.onmousemove = this.resetTimer;
            window.onmousedown = this.resetTimer;
            window.ontouchstart = this.resetTimer;
            window.onclick = this.resetTimer;
            window.onkeydown = this.resetTimer;
            window.addEventListener('scroll', this.resetTimer, true); // improved; see comments
        },
        resetTimer() {
            clearTimeout(this.t);
            let seconds  = this.timeOut * 60 * 1000;
            this.t = setTimeout(this.doLogout, seconds);
        }
    },
    mounted() {
        if (this.timeOut != undefined)
            this.idleLogout()
    }
};
